import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  name: () => [
    validations.required.text(),
    validations.min.text(3),
    validations.max.text(255),
  ],
  editor: () => [validations.min.text(3)],
  image: () => [validations.required.text()],
  level: (field?:any) => [
        // validations.required.text(field),
        validations.pattern.numeric
    ],
};
